module.exports = __webpack_public_path__ + "media/bgm.b72135cc.mp3";